<template>
  <div class="smart-container">
    <div class="text1">畅言智慧课堂</div>
    <div class="text2">为了少年儿童的健康成长、快乐学习</div>
    <img src="../assets/smartClass.png" alt="" class="img">
    <div class="gray">
      <div class="map-content" :style="{backgroundImage:`url(${img})`}">
        <div class="map-text">我公司研发的“智慧课堂”教育信息化产品是以建构主义学习理论为依据，以“互联网+”的思维方式和大数据、云计算等新一代信息技术打造的智能、高效的课堂。其实质，是基于动态学习数据分析和“云、网、端”的运用，实现教学决策数据化、评价反馈即时化、交流互动立体化、资源推送智能化，创设有利于协作交流和意义建构的学习环境，通过智慧的教与学，促进全体学生实现符合个性化成长规律的智慧发展。</div>
        <div class="pop-card">
            目前，智慧课堂在学校教学中已经实现了常态化应用，在北京、广东、江苏、浙江、陕西、辽宁、安徽等三十余个省市自治区有超过一千所学校的应用案例，包括深圳中学、西安交大附中、广州一中、大连24中、无锡一中、北航实验学校，以及安徽包括合肥一、六、八中，蚌埠二中在内的六十余所百强名校。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'smartClass',
    data () {
      return {
        img: require('../assets/company-map.png')
      }
    },
  }
</script>

<style scoped>

.gray{
  background:rgba(247,247,247,1);
  width: 100%;
  display: flex;
  justify-content: center;
}
.map-content{
  width: 63.54%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* height: 1050px; */
  /* background-image: url('../assets/company-map.png'); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  text-indent: 2em;
}
.map-title{
  font-size:26px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  margin-top: 68px;
}
.map-text{
  width: 100%;
  font-size:14px;
  color:rgba(68,68,68,1);
  line-height:30px;
  margin-top: 34px;
  text-align: center;
}
.pop-card{
  margin-top: 450px;
  width: 46.23%;
  color:rgba(68,68,68,1);
  line-height:30px;
  font-size:14px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 2em;
  background: #D6EBFE;
  align-self: flex-start;
  margin-bottom: 50px;
  position: relative;
  padding: 46px 27px;
}
.pop-card::before{
  content: '';
  width: 0;
  height: 0;
  border: 15px solid;
  position: absolute;
  top: -30px;
  right:50px;
  transform: rotate(180deg);
  border-color: #D6EBFE transparent transparent;
}

.smart-container{
  width: 100%;
  /* height:775px; */
  background:linear-gradient(0deg,rgba(43,196,253,1),rgba(29,114,221,1));
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.text1{
  font-size:66px;
  font-family:SourceHanSansCN-Regular;
  font-weight:bold;
  color:rgba(255,255,255,1);
  margin-top: 119px;
}
.text2{
  font-size:30px;
  font-family:SourceHanSansCN-Regular;
  font-weight:bold;
  color:rgba(255,255,255,1);
  opacity:0.5;
  margin-top: 33px;
}
.img{
  margin-top: -120px;
  /* position: absolute;
  bottom: 0; */
}
</style>



// WEBPACK FOOTER //
// src/components/smart-class.vue